<template>
    <div>
        <div class="h-screen flex flex-col">
            <navbar />

            <div class="flex-1 flex overflow-hidden">
                <sidebar />

                <main class="flex-1 flex bg-gray-200">
                    <div class="flex-1 flex flex-col w-0 overflow-hidden">
                        <div class="flex-1 overflow-y-auto w-full py-8 px-8">
                            <router-view :key="$route.fullPath"></router-view>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "./partials/navbar"
import Sidebar from "./partials/sidebar"

export default {
    components: {
        Navbar,
        Sidebar
    },

    data() {
        return {}
    },

    mounted() { }
}
</script>